import { formatKey } from "../../core/utils";

class Controller {
  constructor(
    $stateParams,
    Events,
    VariablePlanTransforms,
    VariablePlan,
    Sections
  ) {
    "ngInject";

    this.variablePlanId = $stateParams.id;
    this.Events = Events;
    this.VariablePlanTransforms = VariablePlanTransforms;
    this.VariablePlan = VariablePlan;
    this.sections = Sections.plansSections;

    this.onUpdateEvent = this.Events.getUpdateEvent("variablePlan");

    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.Events.on(this.onUpdateEvent, this.onUpdate.bind(this));

    this.VariablePlan.get(this.variablePlanId).$promise.then(
      this.initPage.bind(this),
      (response) => {
        this.Events.emit(this.errorNotificationEvent, response.data);
      }
    );
  }

  $onDestroy() {
    this.Events.off(this.onUpdateEvent, this.onUpdate);
  }

  initPage(response) {
    this.variablePlan = this.VariablePlanTransforms.justify(response);
  }

  onUpdate(item) {
    const updatedItem = {
      [item.key]: (item.name && item.name._id) || item._id || item.value,
    };
    this.VariablePlan.update(this.variablePlanId, updatedItem).$promise.then(
      (response) => {
        this.toggleField(this.variablePlan[item.key]);
        this.initPage(response);
        this.Events.emit(this.successNotificationEvent, {
          message: `${formatKey(item.key)} is updated successfully`,
        });
      },
      (response) => {
        this.Events.emit(this.errorNotificationEvent, response.data);
      }
    );
  }

  toggleField(field) {
    field.isDisabled = !field.isDisabled;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/variablePlan/variablePlan.controller.js